var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 1.5,
    fill: "url(#paint0_linear_4044_30443)",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17145 11.729C8.36257 11.46 8.53132 11.2034 8.71872 10.962C9.41983 10.0535 10.0958 9.12315 10.8398 8.25169C11.5838 7.38023 12.3772 6.53158 13.1976 5.7257C14.1131 4.82953 15.1201 4.03505 16.2789 3.48575C16.705 3.28523 17.1712 3.15599 17.6187 3.01249C17.725 2.97922 17.8555 3.02199 17.9739 3.03054L18 3.10942C17.9315 3.20284 17.8547 3.28968 17.7706 3.36886C16.5185 4.35531 15.4781 5.55654 14.4674 6.78057C13.8148 7.56175 13.1687 8.35528 12.5748 9.18302C12.1105 9.85094 11.6808 10.5431 11.2873 11.2567C10.7046 12.2754 10.1442 13.3094 9.59511 14.3471C9.41796 14.6826 9.30981 15.0542 9.16157 15.4058C9.05529 15.6567 8.90519 15.8724 8.63108 15.9608C8.5005 16.0129 8.35549 16.0131 8.22478 15.9613C8.09407 15.9096 7.98719 15.8097 7.92531 15.6814C7.70529 15.287 7.49738 14.886 7.27269 14.4954C6.55358 13.2394 5.70231 12.0671 4.73397 10.9991C4.2417 10.4631 3.70842 9.9661 3.20683 9.43961C3.10707 9.33507 2.984 9.16876 3.00171 9.04997C3.03062 8.8542 3.24878 8.90077 3.39702 8.90172C4.04312 8.90172 4.59972 9.18682 5.14699 9.49853C6.14551 10.0602 7.04613 10.7615 7.90946 11.5161C7.98405 11.5817 8.0633 11.6415 8.17145 11.729Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4044_30443",
    x1: 0,
    y1: 10,
    x2: 18.4127,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListicon);
export default __webpack_public_path__ + "static/media/listicon.64354274b017e1b47f07cf05671bdc89.svg";
export { ForwardRef as ReactComponent };